import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn/ui-style classname helper. Merges Tailwind classes intelligently
 * (later classes override earlier conflicting ones). Keep imports minimal —
 * this is the one util every component imports.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
